/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as React from 'react';
import { SdsDivProps } from '../Component.props';
import { FORM_FIELD_LABEL_POSITION_TOP, FormFieldLabelPosition } from './FormField.types';

/**
 * The base props of each form field.
 */
export interface FormFieldProps extends SdsDivProps {
  /**
   * The change event handler.
   */
  customChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;

  /**
   * Child component.
   */
  children?: React.ReactNode;

  /**
   * The disabled state of the form field.
   */
  disabled?: boolean;

  /**
   * The error message to display.
   */
  errorMessage?: string | null;

  /**
   * The label of the form field.
   */
  fieldLabel: string;

  /**
   * Toggle the display of the label.
   */
  hideLabel?: boolean;

  /**
   * The unique id for the field.
   */
  id: string;

  /**
   * The position of the label.
   */
  labelPosition?: FormFieldLabelPosition;

  /**
   * The name for the field.
   */
  name: string;

  /**
   * The help note of the form field.
   */
  note?: string;

  /**
   * Set the form field to be read only.
   */
  readOnly?: boolean;

  /**
   * The required state of the form field.
   */
  required?: boolean;

  /**
   * The value of the form field.
   */
  value?: string;
}

/**
 * The default prop values for `<FormField />`.
 */
export const formFieldPropsDefaults = {
  labelPosition: FORM_FIELD_LABEL_POSITION_TOP,
};
